import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newCard"]

  showNew(event) {
    event.preventDefault()
    this.resetNewForm()
    this.newCardTarget.classList.remove("hidden")
    const nameInput = this.newCardTarget.querySelector(
      "input[name='market[name]']"
    )
    if (nameInput) nameInput.focus()
  }

  escapeNew() {
    this.hideNew()
  }

  hideNew(event) {
    if (event) event.preventDefault()
    this.newCardTarget.classList.add("hidden")
    this.resetNewForm()
  }

  formSubmitted(event) {
    if (event.detail.success) {
      this.hideNew()
    }
  }

  resetNewForm() {
    const form = this.newCardTarget.querySelector("form")
    if (form) form.reset()
    const hiddenInputs = this.newCardTarget.querySelector(
      "[data-market-edit-target='hiddenInputs']"
    )
    if (hiddenInputs) hiddenInputs.innerHTML = ""
    this.newCardTarget
      .querySelectorAll("[data-state][aria-pressed]")
      .forEach((btn) => {
        btn.setAttribute("aria-pressed", "false")
      })
    const countLabel = this.newCardTarget.querySelector(
      "[data-market-edit-target='countLabel']"
    )
    if (countLabel) countLabel.textContent = "0"
  }
}
